import {
  apiPutUserInitialised,
  apiGetFavouriteCasinosSummary,
  apiGetFavouriteCasinos,
  apiPutFavouriteCasino,
  apiDeleteFavouriteCasino,
  apiGetRecentlyPlayedGames,
  apiGetFavouriteGamesSummary,
  apiGetFavouriteGames,
  apiPutFavouriteGame,
  apiDeleteFavouriteGame,
  apiGetFavouriteOffersSummary,
  apiGetFavouriteOffers,
  apiPutFavouriteOffer,
  apiDeleteFavouriteOffer,
  apiGetFavouriteSuppliersSummary,
  apiGetFavouriteSuppliers,
  apiPutFavouriteSupplier,
  apiDeleteFavouriteSupplier,
  apiGetCasino,
  apiGetGame,
  apiGetOffer,
  apiGetSupplier,
  apiGetMore
} from '@/api';

import * as types from '@/store/mutation-types';

// Utilities
import { capitalize, pluralize } from '@/utilities';

// Models
import USER from '@/store/models/user';

// initial state
const state = {
  ...USER,
  hasFetchedFavouriteCasinos: false,
  hasFetchedFavouriteGames: false,
  hasFetchedFavouriteOffers: false,
  hasFetchedFavouriteSuppliers: false,
  hasFetchedRecentGames: false
};

// mutations
const mutations = {
  [types.RECEIVED_USER] (state, user) {
    state.createdAt = user.created_at;
    state.email = user.email;
    state.id = user.id;
    state.isSuperAdmin = user.is_super_admin;
    state.isInitialised = user.is_initialised;
    state.name = user.name;
    state.updatedAt = user.updatedAt;
    state.isAuthenticated = true;
  },

  [types.SET_USER_INITIALISED] (state, boolean) {
    state.isInitialised = boolean;
  },

  [types.RECEIVED_FAVOURITE_CASINOS_SUMMARY] (state, casinos) {
    state.favourites.casinos.summary = casinos;
  },

  [types.RECEIVED_FAVOURITE_CASINOS] (state, casinos) {
    state.favourites.casinos.data = casinos.data;
    state.favourites.casinos.meta = casinos.meta;
    state.hasFetchedFavouriteCasinos = true;
  },

  [types.APPEND_FAVOURITE_CASINOS] (state, casinos) {
    casinos.data.forEach(obj => state.favourites.casinos.data.push(obj));

    state.favourites.casinos.meta = casinos.meta;
  },

  [types.ADD_FAVOURITE_CASINO] (state, casino) {
    state.favourites.casinos.summary.unshift({ slug: casino.slug, title: casino.title });
    state.favourites.casinos.data.unshift(casino);
  },

  [types.REMOVE_FAVOURITE_CASINO] (state, casino) {
    state.favourites.casinos.data.find((el, index, arr) => {
      if (el.slug == casino.slug) return arr.splice(index, 1);
    });

    state.favourites.casinos.summary.find((el, index, arr) => {
      if (el.slug == casino.slug) return arr.splice(index, 1);
    });
  },

  [types.RECEIVED_RECENTLY_PLAYED_GAMES] (state, games) {
    state.recentGames = games.data;
    state.hasFetchedRecentGames = true;
  },

  [types.ADD_RECENTLY_PLAYED_GAME] (state, game) {
    state.recentGames.unshift(game);
  },

  [types.RECEIVED_FAVOURITE_GAMES_SUMMARY] (state, games) {
    state.favourites.games.summary = games;
  },

  [types.RECEIVED_FAVOURITE_GAMES] (state, games) {
    state.favourites.games.data = games.data;
    state.favourites.games.meta = games.meta;
    state.hasFetchedFavouriteGames = true;
  },

  [types.APPEND_FAVOURITE_GAMES] (state, games) {
    games.data.forEach(obj => state.favourites.games.data.push(obj));

    state.favourites.games.meta = games.meta;
  },

  [types.ADD_FAVOURITE_GAME] (state, game) {
    state.favourites.games.summary.unshift({ slug: game.slug, title: game.title });
    state.favourites.games.data.unshift(game);
  },

  [types.REMOVE_FAVOURITE_GAME] (state, game) {
    state.favourites.games.data.find((el, index, arr) => {
      if (el.slug === game.slug) return arr.splice(index, 1);
    });

    state.favourites.games.summary.find((el, index, arr) => {
      if (el.slug === game.slug) return arr.splice(index, 1);
    });
  },

  [types.RECEIVED_FAVOURITE_OFFERS_SUMMARY] (state, offers) {
    state.favourites.offers.summary = offers;
  },

  [types.RECEIVED_FAVOURITE_OFFERS] (state, offers) {
    state.favourites.offers.data = offers.data;
    state.favourites.offers.meta = offers.meta;
    state.hasFetchedFavouriteOffers = true;
  },

  [types.APPEND_FAVOURITE_OFFERS] (state, offers) {
    offers.data.forEach(obj => state.favourites.offers.data.push(obj));

    state.favourites.offers.meta = offers.meta;
  },

  [types.ADD_FAVOURITE_OFFER] (state, offer) {
    state.favourites.offers.summary.unshift({ slug: offer.slug, title: offer.title });
    state.favourites.offers.data.unshift(offer);
  },

  [types.REMOVE_FAVOURITE_OFFER] (state, offer) {
    state.favourites.offers.data.find((el, index, arr) => {
      if (el.slug === offer.slug) return arr.splice(index, 1);
    });

    state.favourites.offers.summary.find((el, index, arr) => {
      if (el.slug === offer.slug) return arr.splice(index, 1);
    });
  },

  [types.RECEIVED_FAVOURITE_SUPPLIERS_SUMMARY] (state, suppliers) {
      state.favourites.suppliers.summary = suppliers;
    },

    [types.RECEIVED_FAVOURITE_SUPPLIERS] (state, suppliers) {
      state.favourites.suppliers.data = suppliers.data;
      state.favourites.suppliers.meta = suppliers.meta;
      state.hasFetchedFavouriteOffers = true;
    },

    [types.APPEND_FAVOURITE_SUPPLIERS] (state, suppliers) {
      suppliers.data.forEach(obj => state.favourites.suppliers.data.push(obj));

      state.favourites.suppliers.meta = suppliers.meta;
    },

    [types.ADD_FAVOURITE_SUPPLIER] (state, supplier) {
      state.favourites.suppliers.summary.unshift({ slug: supplier.slug, title: supplier.title });
      state.favourites.suppliers.data.unshift(supplier);
    },

    [types.REMOVE_FAVOURITE_SUPPLIER] (state, supplier) {
      state.favourites.suppliers.data.find((el, index, arr) => {
        if (el.slug === supplier.slug) return arr.splice(index, 1);
      });

      state.favourites.suppliers.summary.find((el, index, arr) => {
        if (el.slug === supplier.slug) return arr.splice(index, 1);
      });
    }
};

const actions = {
  setUser: ({ commit }, user) => {
    commit(types.RECEIVED_USER, user);
  },

  setUserInitialised: ({ commit }) => {
    return apiPutUserInitialised().then(({ data }) => {
      commit(types.SET_USER_INITIALISED, data)
    })
    .catch(error => {
      console.log(error);
    })
  },

  getFavouriteCasinosSummary: ({ commit }) => {
    return apiGetFavouriteCasinosSummary()
      .then(({ data }) => {
        commit(types.RECEIVED_FAVOURITE_CASINOS_SUMMARY, data.data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  getFavouriteCasinos: ({ commit }) => {
    return apiGetFavouriteCasinos().then(({ data }) => {
      commit(types.RECEIVED_FAVOURITE_CASINOS, data);
    })
    .catch(error => {
      console.log(error);
    });
  },

  getMoreFavouriteCasinos: ({ commit }, url) => {
    return apiGetMore(url).then(({ data }) => {
      commit(types.APPEND_FAVOURITE_CASINOS, data);
    })
    .catch(error => {
      console.log(error);
    });
  },

  addCasinoAsFavourite: ({ commit, state, dispatch }, casino) => {
    if (state.isAuthenticated) {
      return apiPutFavouriteCasino(casino.slug).then(({ data }) => {
        commit(types.ADD_FAVOURITE_CASINO, casino);
        dispatch('addToast', { type: 'success', text: 'Casino added to favourites' });
      })
      .catch(error => {
        console.log(error);
      });
    }
  },

  removeCasinoAsFavourite: ({ commit, dispatch }, casino) => {
    return apiDeleteFavouriteCasino(casino.slug).then(({ data }) => {
      commit(types.REMOVE_FAVOURITE_CASINO, casino);
      dispatch('addToast', { type: 'success', text: 'Casino removed from favourites' });
    })
    .catch(error => {
      console.log(error);
    });
  },

  getRecentlyPlayedGames: ({ commit, state }) => {
    return apiGetRecentlyPlayedGames().then(({ data }) => {
      commit(types.RECEIVED_RECENTLY_PLAYED_GAMES, data);
    })
    .catch(error => {
      console.log(error);
    });
  },

  getFavouriteGamesSummary: ({ commit }) => {
    return apiGetFavouriteGamesSummary()
      .then(({ data }) => {
        commit(types.RECEIVED_FAVOURITE_GAMES_SUMMARY, data.data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  getFavouriteGames: ({ commit }) => {
    return apiGetFavouriteGames().then(({ data }) => {
      commit(types.RECEIVED_FAVOURITE_GAMES, data);
    })
    .catch(error => {
      console.log(error);
    });
  },

  getMoreFavouriteGames: ({ commit }, url) => {
    return apiGetMore(url).then(({ data }) => {
      commit(types.APPEND_FAVOURITE_GAMES, data);
    })
    .catch(error => {
      console.log(error);
    });
  },

  addGameAsFavourite: ({ commit, state, dispatch }, game) => {
    if (state.isAuthenticated) {
      return apiPutFavouriteGame(game.slug).then(({ data }) => {
        commit(types.ADD_FAVOURITE_GAME, game);
        dispatch('addToast', { type: 'success', text: 'Game added to favourites' });
      })
      .catch(error => {
        console.log(error);
      });
    }
  },

  removeGameAsFavourite: ({ commit, dispatch }, game) => {
    return apiDeleteFavouriteGame(game.slug).then(({ data }) => {
      commit(types.REMOVE_FAVOURITE_GAME, game);
      dispatch('addToast', { type: 'success', text: 'Game removed from favourites' });
    })
    .catch(error => {
      console.log(error);
    });
  },

  getFavouriteOffersSummary: ({ commit }) => {
    return apiGetFavouriteOffersSummary()
      .then(({ data }) => {
        commit(types.RECEIVED_FAVOURITE_OFFERS_SUMMARY, data.data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  getFavouriteOffers: ({ commit }) => {
    return apiGetFavouriteOffers().then(({ data }) => {
      // Add is_favourite key to each
      const offers = data.data.map((el) => {
        return {
          ...el,
          is_favourite: true
        }
      });

      commit(types.RECEIVED_FAVOURITE_OFFERS, { data: offers, meta: data.meta });
    })
    .catch(error => {
      console.log(error);
    });
  },

  getMoreFavouriteOffers: ({ commit }, url) => {
    return apiGetMore(url).then(({ data }) => {
      commit(types.APPEND_FAVOURITE_OFFERS, data);
    })
    .catch(error => {
      console.log(error);
    });
  },

  addOfferAsFavourite: ({ commit, state, dispatch }, offer) => {
    if (state.isAuthenticated) {
      return apiPutFavouriteOffer(offer.slug).then(({ data }) => {
        commit(types.ADD_FAVOURITE_OFFER, offer);
        dispatch('addToast', { type: 'success', text: 'Offer added to favourites' });
      })
      .catch(error => {
        console.log(error);
      });
    }
  },

  removeOfferAsFavourite: ({ commit, dispatch }, offer) => {
    return apiDeleteFavouriteOffer(offer.slug).then(({ data }) => {
      commit(types.REMOVE_FAVOURITE_OFFER, offer);
      dispatch('addToast', { type: 'success', text: 'Offer removed from favourites' });
    })
    .catch(error => {
      console.log(error);
    });
  },

  getFavouriteSuppliersSummary: ({ commit }) => {
    return apiGetFavouriteSuppliersSummary()
      .then(({ data }) => {
        commit(types.RECEIVED_FAVOURITE_SUPPLIERS_SUMMARY, data.data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  getFavouriteSuppliers: ({ commit }) => {
    return apiGetFavouriteSuppliers()
      .then(({ data }) => {
        // Add is_favourite key to each
        const suppliers = data.data.map((el) => {
          return {
            ...el,
            is_favourite: true
          }
        });

        commit(types.RECEIVED_FAVOURITE_SUPPLIERS, { data: suppliers, meta: data.meta });
      })
      .catch(error => {
        console.log(error);
      });
  },

  getMoreFavouriteSuppliers: ({ commit }, url) => {
    return apiGetMore(url)
      .then(({ data }) => {
        commit(types.APPEND_FAVOURITE_SUPPLIERS, data);
      })
      .catch(error => {
        console.log(error);
      });
  },

  addSupplierAsFavourite: ({ commit, state, dispatch }, supplier) => {
    if (state.isAuthenticated) {
      return apiPutFavouriteSupplier(supplier.slug)
        .then(({ data }) => {
          commit(types.ADD_FAVOURITE_SUPPLIER, supplier);
          dispatch('addToast', { type: 'success', text: 'Game studio added to favourites' });
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  removeSupplierAsFavourite: ({ commit, dispatch }, supplier) => {
    return apiDeleteFavouriteSupplier(supplier.slug)
      .then(({ data }) => {
        commit(types.REMOVE_FAVOURITE_SUPPLIER, supplier);
        dispatch('addToast', { type: 'success', text: 'Game studio removed from favourites' });
      })
      .catch(error => {
        console.log(error);
      });
  },

  checkForPendingFavourites: ({ dispatch }) => {
    let storedItems = Object.keys(sessionStorage);
    let sessionKeys = []

    storedItems.forEach((key) => {
      if (key.includes('favourite')) {
        sessionKeys.push(key);
      }
    });

    if (sessionKeys.length > 0) {
      dispatch('addPendingFavourites', sessionKeys);
    }
  },

  addPendingFavourites: ({ state, dispatch }, sessionKeys) => {
    function checkForExistingFavourite (type, slug) {
      return state.favourites[type].summary.filter(el => el.slug === slug);
    };

    sessionKeys.forEach(key => {
      let slug = sessionStorage.getItem(key);
      let type = key.slice(key.indexOf('/') + 1);
      let typePlural = pluralize(type);

      if (checkForExistingFavourite(typePlural, slug).length) {
        dispatch('addToast', { type: 'info', text: `Already added to favourite ${ typePlural === 'suppliers' ? 'game studios' : typePlural }` });
        sessionStorage.removeItem(key);
        return;
      }

      if (type === 'casino') {
        return apiGetCasino(slug)
          .then(({ data }) => {
            dispatch('addCasinoAsFavourite', data);
            sessionStorage.removeItem(key);
          });
      } else if (type === 'game') {
        return apiGetGame(slug)
          .then(({ data }) => {
            dispatch('addGameAsFavourite', data);
            sessionStorage.removeItem(key);
          });
      } else if (type === 'offer') {
        return apiGetOffer(slug)
          .then(({ data }) => {
            dispatch('addOfferAsFavourite', data);
            sessionStorage.removeItem(key);
          });
      } else if (type === 'supplier') {
        return apiGetSupplier(slug)
          .then(({ data }) => {
            dispatch('addSupplierAsFavourite', data);
            sessionStorage.removeItem(key);
          });
      } else {
        console.error(`'${ type }' is not a recognized type when adding pending favourites`);
      }
    });
  },
};

const getters = {
  user (state) {
    return state;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/user.js